import { render, staticRenderFns } from "./chartTarifa.vue?vue&type=template&id=5846194e&"
import script from "./chartTarifa.vue?vue&type=script&lang=js&"
export * from "./chartTarifa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports